// cartpage - empty cart - 16-8-2016


$( document ).ready(function() {
    // Find mobile device
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        iPad: function() {
        	return navigator.userAgent.match(/iPad/i);
    	},
    	mobile: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        },
        any: function() {
            return (isMobile.mobile() || isMobile.iPad());
        }
    };
  
  
  
  
  
  
   $(".pick-a-snacks-close.mobile-show, .backto-choose-snacks.mobile-show").click(function(){
    	$(".popup-cart").click();
    });

   
   $(".modal-btn-close").click(function()
  {      sessionStorage["PopupShown"] = 'yes'; 
  });
  if(sessionStorage["PopupShown"] != 'yes'){ 
      setTimeout( function() {
      $("#Modal-1").modal("show");
      }, 20000);
     }
  
// home page popup
  
  
    $('#newsletter-validation').validate({
		    rules: {
		       EMAIL:{
		       required: true,
		       email: true
		    }
     },
      messages: {
        EMAIL: {
	          required: "Please enter email address",
	          email: "Please enter valid email address"
        }
      },
      submitHandler: function() {
        var $form = $('#newsletter-validation');
        $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        success     : function(data) {
             $('form').addClass('hide');
             $('.popup-newsletter p').css('padding-top','45px');
              $('.popup-newsletter p').after('<div class="subscription-thanks"><h2>Thank You for subscription</h2></div>');
              setTimeout( function() {
                    $('.modal-btn-close').click();
                     }, 1500);
          console.log('newsletter: ' + data.result);
        }
    });
      }
  
 });
  

 
$('#gSignIn').click(function() {
  $('.abcRioButtonContentWrapper').click();
});
  
//   login popup homepage - background overflow disable
$('.login-popup').click(function(){
  $(".index-body").css('overflow','hidden');
 });
$("body").on("click", ".close-account-popup", function() {
   $(".index-body").css('overflow','visible');
});

//  view details - background overflow disable
$('.middle-part-sec-2 .animation-zoom.fancybox').click(function(){
  $(".product-body, .customers-order-body").css('overflow','hidden');
 });
$(".product-body, .customers-order-body").on("click", ".closePopup", function() {
   $(".product-body, .customers-order-body").css('overflow','visible');
});

$('.choose-snack.surprise-choose-snack').click(function(){
    $(".product-body").css('overflow','hidden');
  });
  $(".product-body").on("click", ".surprise-popup-close-button", function() {
   $(".product-body").css('overflow','visible');
});
  
//   To avoid onfocus(textfield, input) on mobileview
//   if (/iPhone/.test(navigator.userAgent) && !window.MSStream)
//     {
//         $(document).on("focus", "input, textarea, select", function()
//         {
//             $('meta[name=viewport]').remove();
//             $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">');
//         });

//         $(document).on("blur", "input, textarea, select", function()
//         {
//             $('meta[name=viewport]').remove();
//             $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">');
//         });
//     }
  
// Nutritional table in GYB page
  var ele;
  var init_width;
  var init_top;
  var init_left;
  var nutrition_img_width;
  
//   $('.nutritional-table-link').click(function() {alert($(this).html);});
  $('.product-body').on("click", ".nutritional-table-link", function(){
	ele = $(this).parents('.product_details');
    init_width = ele.css('width');
    init_top = ele.css('margin-top');
    init_left = ele.css('margin-left');
    var nutrition_img = $('.description-div .nutrition-table');
    nutrition_img.css({'display':'block', 'visibility':'hidden'});
    nutrition_img_width = nutrition_img.outerWidth();
    
    $('.product_details').append('<h2 class="nutrition-table-title"> Nutritional Facts </h2>');
    $('.product-description .nutrition-table').first().clone().appendTo('.product_details');   
    $('.product_details').addClass('nutrition-table-wrap');
    $('.nutrition-table-wrap').css('width','auto');
    $('.description-product-image.xs-hide').addClass('hide');
    $('.product-description').addClass('hide');
    $('.product_details .closePopup').addClass('hide');
    $('.nutrition-table').after('<a class="product_details-closePopup nutrition-table-close">Back</a>');                                                                  
    $('.nutrition-table').after('<a class="nutrition-table-closePopup "><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size:1.5em;"></i></a>');   
    
    // Set margin-top based on nutrition table height
    if(isMobile.mobile()){
    	var new_top = (ele.outerHeight())/-2;
    	var new_left = (nutrition_img_width+30)/-2;
        $('.nutrition-table-wrap').css('width','80%');
    }
    else {
      var new_top = ele.outerHeight()/-2;
      var new_left = (nutrition_img_width+80)/-2;
    }
    
    ele.css({'margin-top' : new_top+'px', 'margin-left' : new_left+'px'});
    $('.product_details > .nutrition-table').css({'visibility':'visible'});
  });
  $('.product-body').on("click", ".product_details-closePopup", function(){
    $('.product_details > .nutrition-table, .nutrition-table-title, .product_details-closePopup, .nutrition-table-closePopup').remove();
    ele.css({'margin-top' : init_top, 'margin-left' : init_left, 'width' : init_width });
    
    $('.description-product-image.xs-hide').removeClass('hide');
    $('.product-description').removeClass('hide');
    $('.description-div .nutrition-table').css('display', 'none');
    $('.product_details .closePopup').removeClass('hide');
    $('.product_details').removeClass('nutrition-table-wrap');
   
  });
  $('.product-body').on("click", ".nutrition-table-closePopup", function(){
    $('.product_details-closePopup').click();
    $('.product_details .closePopup').click();
  });
  
//   customer/account-page
//   save customer taste perference
   $('.saveMyPreference').click(function() {
     if(!$('body').find('.alert-saveperference').is(':visible')){
       $('body').append('<div class="alert alert-success alert-fixed-top alert-saveperference fade in"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a><strong>Success! </strong> Your Preference has been saved with us.</div>');
       setTimeout(function(){ $('.alert-saveperference .close').click() }, 2000);
     }     
   });
  
});

$(window).load(function() {

  // All snacks
  $(".products").masonry({      
    itemSelector: '.product',
    columnWidth: 0
    // percentPosition: true
  });
  
$.validator.methods.email = function( value, element ) {
    return this.optional( element ) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm.test( value );
} 
   
  
});

  
    
